import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserFormComponent } from './user-form/user-form.component';
import { UserComponent } from './user.component';
import { AuthGuardMaxUsers } from 'lib-trend-core'

// /user
const routes: Routes = [
  { path: '', component: UserComponent, },
  { path: 'new', component: UserFormComponent, canActivate: [AuthGuardMaxUsers] },
  { path: ':id/edit', component: UserFormComponent, },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
